import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkActivateProducts, productsQueryKeys } from '@api/products';
import { asyncTasksQueryKeys } from '@api/asyncTasks';
import { ApiError } from '@api/client';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from '../useTranslation';

export interface BulkActivateProductsInput {
  ids: number[];
  count: number;
}

export function useBulkActivateProducts() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({ ids }: BulkActivateProductsInput) => bulkActivateProducts(ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: productsQueryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: asyncTasksQueryKeys.lists() });
    },
    onError: (error, variables) => {
      const description = error instanceof ApiError && error.status < 500
        ? error.message
        : t('bulk_bar.toast.error_generic');

      toast({
        title: t('bulk_bar.products_error', { count: variables.count }),
        description,
        variant: 'destructive',
      });
    },
  });
}
